import { z } from 'zod';
import { PromotionType } from '../../constants/promotion-type.js';
import { PROMOTION_CONSTRAINTS } from './constraints.js';
export const promotionTypeSchema = z.enum(PromotionType, {
    error: `Select a ${PROMOTION_CONSTRAINTS.type.label.toLowerCase()}: Product or Percentage Match.`,
});
//# sourceMappingURL=promotion-type-schema.js.map